class Nav {
    constructor() {
        let handles = document.querySelectorAll('.js-nav-handle');
        for (let i = 0; i < handles.length; i++) {
            handles[i].addEventListener('click', this.toggleNav);
        }
    }

    toggleNav() {
        let matches = document.querySelectorAll('html, body');
        for (let i = 0; i < matches.length; i++) {
            matches[i].classList.toggle('nav-active');
        }
    }
}

export default Nav;
